import React, { Component, Fragment } from 'react'
import { ApolloConsumer } from 'react-apollo'

import helpers from '../../helpers'

import { USERNAME_QUERY } from '../../queries'

import { Container, Header, LoginContainer, Feedback, IconContainer } from './styles'

import { ProActiveLogo, AFASLogo } from '../../components/Icons'

class OCIForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      secondPassword: '',
      stayLoggedIn: '',
      usernameValid: '',
      passwordStrength: {
        minimal: '',
        strength: 0
      }
    }

    this.checkForUsername = this.checkForUsername.bind(this)
  }

  componentDidMount() {
    this.timer = null
  }

  async checkForUsername() {
    if (this.state.username !== '') {
      const { data } = await this.client.query({
        query: USERNAME_QUERY,
        variables: { username: this.state.username }
      })
      if (data.usernameExists || this.state.username.length < 4) {
        if (data.usernameExists) {
          this.setState({ usernameValid: 'Gebruikersnaam is bezet' })
        } else {
          this.setState({ usernameValid: 'Gebruikersnaam moet minimaal 4 tekens bevatten' })
        }
      } else {
        this.setState({ usernameValid: 'true' })
      }
    }
  }

  handleChange(e) {
    if (this.props.activate) {
      if (e.target.name === 'username') {
        clearTimeout(this.timer)
        this.setState({ username: e.target.value, usernameValid: '' })
        this.timer = setTimeout(this.checkForUsername, 1000)
      } else if (e.target.name === 'password') {
        this.setState({
          password: e.target.value,
          passwordStrength: helpers.calculatePasswordStrenght(e.target.value)
        })
      } else if (e.target.name === 'second_password') {
        this.setState({ secondPassword: e.target.value })
      }
    } else {
      e.target.name === 'username'
        ? this.setState({ username: e.target.value })
        : this.setState({ password: e.target.value })
    }
  }

  handleClick(e) {
    this.state.stayLoggedIn === 'checked'
      ? this.setState({ stayLoggedIn: '' })
      : this.setState({ stayLoggedIn: 'checked' })
  }

  handleSubmit(e) {
    e.preventDefault()
    if (this.props.activate) {
      if (
        this.state.passwordStrength.minimal &&
        this.state.usernameValid &&
        this.state.password === this.state.secondPassword
      ) {
        this.props.login(this.state.username, this.state.password)
      }
    } else {
      this.props.login(this.state.username, this.state.password, this.state.stayLoggedIn)
    }
  }

  render() {
    const { activate, type } = this.props
    return (
      <ApolloConsumer>
        {client => {
          this.client = client
          return (
            <Container>
              <Header>{activate ? 'Activeren' : 'Inloggen'}</Header>
              <LoginContainer>
                <IconContainer>
                  {type === 'ProActive' ? (
                    <ProActiveLogo size="" />
                  ) : (type === 'AFAS' ? <AFASLogo /> : <img alt="axxerion" src="https://g8u8y9s9.rocketcdn.me/wp-content/uploads/2022/04/axxerion-logo-2022-1100x200-left-400x73.png" />)}
                </IconContainer>
                {!activate ? (
                  <Fragment>
                    {this.props.loading ? (
                      <Feedback>Laden...</Feedback>
                    ) : (
                      <Feedback>{this.props.feedback ? this.props.feedback : ''}</Feedback>
                    )}
                  </Fragment>
                ) : null}
              </LoginContainer>
            </Container>
          )
        }}
      </ApolloConsumer>
    )
  }
}

export default OCIForm



// WEBPACK FOOTER //
// ./src/containers/OCIForm/index.js